export class LoginFooter {
    constructor() {}

    public get currentYear(): number {
        const d = new Date();
        return d.getFullYear();
    }
}
